/**
 * Handle behaviour of showing and hiding bulletin respond section
 */
jQuery(function($) {
	$('.comment-title').on('click', function() {
		$(this).next('.respond').toggleClass('active');
		$(this).hide();
	});
});